import React, { ReactNode } from 'react';
import { useIntl } from 'react-intl';

import { useDetailModal } from '~/eds/src/components/hooks/useDetailModal';
import { Text } from '~/eds/src/components/Text/Text';

import styles from './styles';

type Props = {
  content: string;
  title: string;
  onClose: () => void;
};

const useShowMoreClauseModal = ({
  content,
  title,
  onClose,
}: Props): [ReactNode, () => void] => {
  const intl = useIntl();
  const [clauseModal, showClauseModal] = useDetailModal({
    title: title,
    isFullPage: true,
    onCancel: onClose,
    primaryAction: {
      variant: 'tertiary',
      text: intl.formatMessage({
        id: 'common.close',
        defaultMessage: 'Close',
        description: 'Close button text',
      }),
      onClick: onClose,
    },
    children: (
      <Text styles={styles.clauseContent} px={6}>
        {content}
      </Text>
    ),
  });

  return [clauseModal, showClauseModal];
};

export default useShowMoreClauseModal;
